import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage as ErrorMessageEntity } from '@paysera/error-message-resolver';
import AdditionalErrorData from "./AdditionalErrorData";
var ErrorContext = /*#__PURE__*/React.createContext({
  hasError: false,
  message: null,
  type: null,
  additionalData: new AdditionalErrorData({}),
  error: null,
  logError: null,
  captureBreadcrumb: function captureBreadcrumb() {
    return null;
  },
  dispatchSilentError: function dispatchSilentError() {
    return null;
  },
  dispatchError: function dispatchError() {
    return null;
  },
  clearError: function clearError() {
    return null;
  },
  subscribeError: function subscribeError() {
    return null;
  },
  renderError: function renderError() {
    return null;
  }
});
export default ErrorContext;
export var errorContextShape = {
  hasError: PropTypes.bool.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(ErrorMessageEntity)]),
  type: PropTypes.string,
  additionalData: PropTypes.instanceOf(AdditionalErrorData),
  error: PropTypes.object,
  logError: PropTypes.func.isRequired,
  captureBreadcrumb: PropTypes.func.isRequired,
  dispatchSilentError: PropTypes.func.isRequired,
  dispatchError: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  subscribeError: PropTypes.func.isRequired,
  renderError: PropTypes.func.isRequired
};